import { useState } from "react";
import AgeVerification from "./components/AgeVerification";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import SessionSection from "./components/SessionSection";
import PriceSection from "./components/PriceSection";
import ScheduleSection from "./components/ScheduleSection";
import HowToBookSection from "./components/HowToBookSection";
import GallerySection from "./components/GallerySection";
import VideoSection from "./components/VideoSection";
import ReviewsSection from "./components/ReviewsSection";
import BlogSNSSection from "./components/BlogSNSSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "むぎ茶 SM・M性感 個人セッション｜むぎ茶プロダクション",
    description: "むぎ茶の公式サイト。SM・M性感をベースにした完全プライベートな出張セッション。東京都内を中心に活動中。初回・未経験の方も大歓迎です。",
    keywords: "むぎ茶,SM,M性感,出張セッション,東京,フェチ",
    canonical: "https://mugichaproduction.com/",
  });

  const [verified, setVerified] = useState(() => {
    return sessionStorage.getItem("age_verified") === "true";
  });

  return (
    <>
      <AgeVerification onVerified={() => setVerified(true)} />
      {verified && (
        <div className="min-h-screen bg-white flex flex-col">
          <Navbar />
          <main className="flex-1">
            <HeroSection />
            <AboutSection />
            <SessionSection />
            <PriceSection />
            <ScheduleSection />
            <HowToBookSection />
            <GallerySection />
            <VideoSection />
            <ReviewsSection />
            <BlogSNSSection />
            <ContactSection />
          </main>
          <FooterSection />
        </div>
      )}
    </>
  );
}